import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleCall = () => {
        window.location.href = 'tel:+17472656569';
    };

    return (
        <header className="bg-white shadow-md sticky top-0 z-50">
            <div className="container mx-auto px-4 py-3 flex justify-between items-center">
                <Link to="/" className="flex items-center">
                    <img src="/logo.png" alt="Drive Today Auto Logo" className="h-12 mr-2" />
                    <h1 className="text-2xl font-bold text-gray-800">Drive Today <span className="text-red-600">Auto</span></h1>
                </Link>
                
                <nav className="hidden md:flex space-x-8">
                    <Link to="/" className="text-gray-800 hover:text-red-600 font-medium">Home</Link>
                    <a href="https://drivetodayauto.mycarsonline.com/inventory" className="text-gray-800 hover:text-red-600 font-medium">Inventory</a>
                    <a href="#services" className="text-gray-800 hover:text-red-600 font-medium">Services</a>
                    <a href="#about" className="text-gray-800 hover:text-red-600 font-medium">About</a>
                    <a href="#contact" className="text-gray-800 hover:text-red-600 font-medium">Contact</a>
                    <Link to="/get-offer" className="text-red-600 hover:text-red-700 font-medium">Get Offer</Link>
                </nav>
                
                <div className="flex items-center space-x-4">
                    <button 
                        className="md:hidden text-gray-800" 
                        onClick={toggleMobileMenu}
                        aria-label="Toggle mobile menu"
                    >
                        <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'} text-2xl`}></i>
                    </button>
                    <button 
                        onClick={handleCall}
                        className="hidden md:block bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition"
                    >
                        <i className="fas fa-phone-alt mr-2"></i> (747) 265-6569
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            <div className={`md:hidden bg-white w-full py-4 px-4 shadow-md ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
                <div className="flex flex-col space-y-3">
                    <Link to="/" className="text-gray-800 hover:text-red-600 font-medium py-2 border-b" onClick={toggleMobileMenu}>Home</Link>
                    <a href="https://drivetodayauto.mycarsonline.com/inventory" className="text-gray-800 hover:text-red-600 font-medium py-2 border-b" onClick={toggleMobileMenu}>Inventory</a>
                    <a href="#services" className="text-gray-800 hover:text-red-600 font-medium py-2 border-b" onClick={toggleMobileMenu}>Services</a>
                    <a href="#about" className="text-gray-800 hover:text-red-600 font-medium py-2 border-b" onClick={toggleMobileMenu}>About</a>
                    <a href="#contact" className="text-gray-800 hover:text-red-600 font-medium py-2 border-b" onClick={toggleMobileMenu}>Contact</a>
                    <Link to="/get-offer" className="text-red-600 hover:text-red-700 font-medium py-2 border-b" onClick={toggleMobileMenu}>Get Offer</Link>
                    <button 
                        onClick={handleCall}
                        className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 transition w-full"
                    >
                        <i className="fas fa-phone-alt mr-2"></i> (747) 265-6569
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header; 